import { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate("/login");
      return;
    }
    let alive = true;
    (async () => {
      // Verificar role — apenas lojistas/admins podem acessar o painel
      const { data: roles } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", user.id);
      const rolesList = roles?.map((r) => r.role) || [];
      const isMerchant = rolesList.includes("store_owner") || rolesList.includes("admin");
      if (!alive) return;
      if (!isMerchant) {
        toast.error("Área exclusiva para lojistas.");
        navigate("/meus-pedidos", { replace: true });
        return;
      }

      const { data: sub } = await supabase
        .from("subscriptions")
        .select("status")
        .eq("user_id", user.id)
        .maybeSingle();
      if (!alive) return;
      const activationAllowedPaths = [
        "/ativar-conta",
        "/configuracoes",
        "/configuracoes-loja",
        "/configuracoes-da-loja",
        "/configurações-loja",
        "/configurações-da-loja",
        "/configuracao-loja",
        "/configuracao-da-loja",
        "/configuracoes/loja",
        "/loja/configuracoes",
      ];
      if (sub?.status === "pending_activation" && !activationAllowedPaths.includes(location.pathname)) {
        navigate("/ativar-conta", { replace: true });
        return;
      }
      if ((sub?.status === "blocked" || sub?.status === "expired") &&
          location.pathname !== "/meu-plano" &&
          location.pathname !== "/dashboard/meu-plano") {
        navigate("/dashboard/meu-plano", { replace: true });
        return;
      }
      setChecking(false);
    })();
    return () => {
      alive = false;
    };
  }, [user, loading, navigate, location.pathname]);

  if (loading || checking) {
    return <div className="min-h-screen flex items-center justify-center">Carregando...</div>;
  }
  if (!user) return null;
  return <>{children}</>;
};
